import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../context/TranslationContext';
import useDocumentTitle from '../hooks/useDocumentTitle';

/* Vercel sirve build/404.html (con estado 404) para cualquier URL que no
   exista; React Router cae aquí. */
const COPY = {
  es: {
    title: 'Página no encontrada',
    body: 'Esta página no existe o ha cambiado de dirección.',
    back: 'Volver al inicio',
  },
  en: {
    title: 'Page not found',
    body: "This page doesn't exist or has moved.",
    back: 'Back to home',
  },
};

export default function NotFound() {
  const { lang } = useTranslation();
  const c = COPY[lang] || COPY.es;
  useDocumentTitle(`${c.title} · Qyntix`);

  return (
    <main id="main" className="article">
      <div className="wrap">
        <div className="article-inner">
          <p className="t-small mono">404</p>
          <h1>{c.title}</h1>
          <p className="t-lead">{c.body}</p>
          <p style={{ marginTop: 32 }}><Link to="/" className="link">{c.back}</Link></p>
        </div>
      </div>
    </main>
  );
}
